import React from "react";
import { Form } from "react-crud-form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Input } from "ui/components/input";
import { useNavigate } from "react-router-dom";
import { questionSchema } from "./schema";
import { FormActions } from "components/form/actions";
import { useQuestionForm } from "./useQuestionForm";
import { PermissionControlledInput } from "permissions/components/input";
import { FormLabel } from "components/form";
import SelectStatus from "components/select/status";
import SelectName from "components/select/name";
import { Textarea } from "ui/components/textarea";

const QuestionForm = ({ questionId }) => {
  const navigate = useNavigate();
  const { form, handleCreate, handleUpdate, handleRead } = useQuestionForm({
    questionId,
  });

  return (
    <Form
      form={form}
      create={handleCreate}
      update={handleUpdate}
      read={handleRead}
      itemId={questionId || "+"}
      schema={questionSchema}
    >
      {({
        isCreating,
        createItem,
        isNewItem,
        updateItem,
        isUpdating,
        isDirty,
      }) => (
        <div className="space-y-6">
          {/* Name Field */}
          <FormField
            control={form.control}
            name="question"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="survey_questions"
                  type="form"
                >
                  <FormLabel required>Question</FormLabel>
                  <Textarea {...field} />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="category"
            render={({ field }) => (
              <FormItem>
                <FormLabel required>Category</FormLabel>
                <SelectName
                  collection="survey_categories"
                  onValueChange={val => field.onChange(val)}
                  fetchItems={true}
                  {...field}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="status"
            render={({ field }) => (
              <FormItem>
                <FormLabel required>Status</FormLabel>
                <SelectStatus
                  collection="survey_questions"
                  onValueChange={val => field.onChange(val)}
                  {...field}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormActions
            isNewItem={isNewItem}
            isCreating={isCreating}
            isUpdating={isUpdating}
            isDirty={isDirty}
            createItem={() => createItem().then(() => navigate(-1))}
            updateItem={() => updateItem().then(() => navigate(-1))}
            showCancel={false}
            collection="survey_questions"
            rule={isNewItem ? "create:*" : "update:*"}
          />
        </div>
      )}
    </Form>
  );
};

export default QuestionForm;
